import Order from ".";
import ManageOrder from "../../../../components/sections/admin/Order/ManageOrder";

export const orderRoutes = (data) => {
  return [
    {
      path: "/admin/order",
      title: "order",
      layout: "admin",
      routeType: "admin",
      component: Order,
    },
    {
      path: "/admin/manage-order",
      component: ManageOrder,
      layout: "admin",
      routeType: "admin",
      title: "Manage Order",
    },
    {
      path: `/admin/manage-order/:id`,
      component: ManageOrder,
      layout: "admin",
      routeType: "admin",
      title: "Manage Order",
    },
  ];
};
